import { Colors } from "_styles";

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//const usedTheme = useSelector(selectUsedTheme);

export const mainContainer = {
    position: "absolute",
    //backgroundColor: usedTheme.BACKGROUND_COLOR,
    //borderColor: usedTheme.BORDER_COLOR,
    //color: usedTheme.TEXT_COLOR,
    //minHeight: "60vh",
    //maxHeight: "60vh",
    borderBottomRightRadius: "25px",
    maxWidth: "512px",
    minWidth: "184px",
    padding: "10px",
    boxShadow: "rgba(50, 50, 93, 0.25) -1px 10px 20px 5px, rgba(0, 0, 0, 0.3) 0px 8px 16px 3px",
    zIndex: 300,
};

export const header = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "fit-content",
    alignItems: "center",
    padding: "10px"
};

export const image = {
    maxWidth: "200px",
    height: "34px",
}

export const icon = {
    borderRadius: "20px",
    // color: "black",
    padding: 5
}